import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
// import Confetti from 'https://cdn.skypack.dev/canvas-confetti';
// import Fireworks from "react-canvas-confetti/dist/presets/fireworks";
import Modal from 'react-bootstrap/Modal';
import { error_api_call, post_api_call } from '../../../actions/action-creators/common';
import { alertResponseMessage } from '../../../actions/action-creators/response';
import Form from 'react-bootstrap/Form';
import { LoaderMedium } from '../../loader';
import SkipIcon from '../../../assets/images/icon/skip.png';
import SuccessAud from '../../../assets/sounds/endorse-success.wav';
import { update_reward_info } from '../../../actions/action-creators/state-update';
import { useCoinAnimation } from '../../../context/CoinAnimationContext';

const familarityOpt = [{id: 2, familiarity: 'Very Well'},
                    {id: 1, familiarity: 'Somewhat'},
                    {id: 0, familiarity: 'Not at All'}];
const ratingOpt = [{id: 3, familiarity: 'High'},
                    {id: 2, familiarity: 'Medium'},
                    {id: 1, familiarity: 'Low'}];

function ModalEndorsePort(props) {
    const dispatch = useDispatch();
    const { triggerCoinAnimation } = useCoinAnimation();
    const [familiarityCurrent, setFamiliarityCurrent] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [questionData, setQuestionData] = useState([]);
    const [activeQuesData, setActiveQuesData] = useState({});
    const [quesAnsweredCount, setAnsweredCount] = useState(0);
    // const [isExploding, setIsExploding] = useState(false);
    let endorseSuccess = new Audio(SuccessAud);
    //Familiarity: Submit
    const handleFamChange = async(e) => {
        e.preventDefault();
        try{
            setIsLoading(true);
            const familarityVal = e.target.value;
            setFamiliarityCurrent(familarityVal);
            //Submit
            const userId = props.data.id;
            const apiData = await post_api_call(`port/action/familiarity`, {user_id: userId, familiarity: familarityVal});
            if(apiData.status === 200){
                //Update Familiarity
                props._updateFamiliarData({familiarity: familarityVal, familiar_date: apiData.familiar_date}, userId);
                //Show Question
                if(familarityVal > 0){
                    setQuestionData([...apiData.question_data]);
                }else{
                    alertResponseMessage({alert_type: 2, message: `To Endorse, you should know ${props.data.first_name}. Know them better to Endorse later. Thank You.`});
                    props.toggleModal(e, false);
                }
            }
            setIsLoading(false);
        }catch(error){
            setIsLoading(false);
            alertResponseMessage({alert_type: 2, message: "Error Submitting Details! Please try after some times"});
            error_api_call({error: `component/modal/portfolio/endorse-port|handleFamChange|${error}`});
        }
    };
    //Fetch Questions
    useEffect(() => {
        const fetchQuestions = async() => {
            try{
                setIsLoading(true);
                setQuestionData([]);
                setActiveQuesData({});
                const userId = props.data.id;
                const apiData = await post_api_call(`endorse-attributes`, {user_id: userId});
                if(apiData.status === 200){
                    const quesData = apiData.question_data;
                    //get first question
                    if(quesData.length > 0){
                        setActiveQuesData({...quesData[0], rate_val: ''});
                    }
                    setQuestionData([...quesData]);
                }
                setIsLoading(false);
            }catch(error){
                setIsLoading(false);
                alertResponseMessage({alert_type: 2, message: "Error Fetching Details! Please try after some times"});
                error_api_call({error: `component/modal/portfolio/endorse-port|fetchQuestions|${error}`});
            }
        };
        if(props.data && props.data.id){
            fetchQuestions();
            setAnsweredCount(0);
            setFamiliarityCurrent('');
            setQuestionData([]);
            setActiveQuesData({});
        }
    }, [props.data.id]);// eslint-disable-line react-hooks/exhaustive-deps
    //Rating
    const submitEndorse = async(e) => {
        e.preventDefault();
        try{
            setIsLoading(true);
            const rating = e.target.value;
            setActiveQuesData({...activeQuesData, rate_val: rating});
            //Submit
            const userId = props.data.id;
            const apiData = await post_api_call(`port/action/endorse`, {user_id: userId,
                                                                        rating,
                                                                        skill_id: activeQuesData.id,
                                                                        is_new: quesAnsweredCount > 0 ? 0 : 1});
            if(apiData.status === 200){
                //Remove first question
                // const updatedQues = [...questionData];
                // updatedQues.splice(0, 1);
                // if(updatedQues.length > 0){
                //     setActiveQuesData({...updatedQues[0], rate_val: ''});
                // }
                // setQuestionData([...updatedQues]);
                // setActiveQuesData({});
                skipQuestion(e, 'success', apiData.data.reward_data);
                const quesAnsCount = quesAnsweredCount+1;
                setAnsweredCount(quesAnsCount);
                //Update Count
                props._updateEndorseData({endorse_count: props.data.port_endorse_count + quesAnsCount}, userId);
            }else{
                setIsLoading(false);
            }
        }catch(error){
            setIsLoading(false);
            alertResponseMessage({alert_type: 2, message: "Error Submitting Details! Please try after some times"});
            error_api_call({error: `component/modal/portfolio/endorse-port|submitEndorse|${error}`});
        }
    };
    //Skip Question
    const skipQuestion = (e, type, data={}) => {
        e.preventDefault();
        try{
            setIsLoading(true);
            //Remove first question
            const updatedQues = [...questionData];
            updatedQues.splice(0, 1);
            if(updatedQues.length > 0){
                const updatedActvQs = {...activeQuesData, ...updatedQues[0], rate_val: ''};
                // setActiveQuesData({...activeQuesData, ...updatedQues[0], rate_val: ''});
                setActiveQuesData({...updatedActvQs});
            }
            setQuestionData([...updatedQues]);
            setIsLoading(false);
            if(type === 'success'){
                //Play Sound
                endorseSuccess.play();
                //Splash gif
                // Confetti({zIndex: 99999, origin: {y: 0.7}});
                // setIsExploding(true);
                // For Point Allocation
                if(data.is_awarded){
                    triggerCoinAnimation(data.point, {show_confetti: false});
                    alertResponseMessage({alert_type: 3, custom: "image", image: data.icon, custom_msg: data.message});
                    //Update Redux
                    dispatch(update_reward_info(data,async cb_data => {
                        // console.log('cb_data', cb_data)
                    }));
                }
            }
        }catch(error){
            console.log(error)
            setIsLoading(false);
            alertResponseMessage({alert_type: 2, message: "Error Submitting Details! Please try after some times"});
            error_api_call({error: `component/modal/portfolio/endorse-port|skipQuestion|${error}`});
        }
    };

    return (
      <> 
        <Modal show={props.isShow||false} onHide={(e) => props.toggleModal(e, false)} size="md" className="mod-custom team-detail student-sec" backdrop="static" enforceFocus={false}>
            <Modal.Header closeButton>
                <Modal.Title>Endorse {props.data.first_name||""}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="col-md-12 col-12 col-sm-12">
                    {/* {props.loader
                        ?
                        <div className="text-center mt-5 mb-5">
                            <LoaderMedium size={45} />
                        </div>
                        : */}
                        <div className="ms-2 me-2">
                            {/* <div className="card"> */}
                            <div className="card mt-3">
                                <div className="row mt-2">
                                <div className="col-md-12 col-12 col-sm-12 text-center">
                                    {(props.familiarityData === null
                                        || props.familiarityData.familiarity === null
                                        || props.familiarityData.familiarity === 0)
                                        ?
                                            <div>
                                            <p className="m-2 mb-3">How well do you know <b><i>{props.data.first_name||""} {props.data.last_name||""}</i></b>?</p>
                                            <Form className="d-inline d-sm-flex justify-content-center mb-3">
                                                {familarityOpt.map((fam_option, fam_index) => (
                                                    <div key={`fam_option-${fam_index}`} className="m-2 mb-3">
                                                    <Form.Check
                                                        value={fam_option.id}
                                                        inline
                                                        // label={fam_option.familiarity}
                                                        name="familiarity"
                                                        type="radio"
                                                        id={`fam-id-${fam_index}`}
                                                        className="btn-check"
                                                        checked={familiarityCurrent === String(fam_option.id) ? true : false}
                                                        onChange={handleFamChange}
                                                        disabled={isLoading}
                                                    />
                                                    <label className={`btn btn-outline-primary ${familiarityCurrent === String(fam_option.id) ? 'active' : (isLoading ? 'disabled' : '')}`} htmlFor={`fam-id-${fam_index}`}>
                                                    {fam_option.familiarity}
                                                    </label>
                                                    </div>
                                                ))}
                                            </Form>
                                            </div>
                                        :
                                            <div>
                                                {questionData.length > 0
                                                    ?
                                                    <div>
                                                    <Form  className="d-inline d-sm-flex justify-content-center">
                                                        <div>
                                                        <p className="m-2">Rate {props.data.first_name||''} as <b>{activeQuesData.skill_name}</b></p>
                                                        <div className="d-inline d-sm-flex justify-content-center mb-3">
                                                        {ratingOpt.map((rate_option, rate_index) => (
                                                            <div key={`ques_option-${rate_index}`} className="m-2 mb-3">
                                                            {/* {activeQuesData.rate_val}, {rate_option.id}, {String(activeQuesData.rate_val)} {String(rate_option.id)} */}
                                                            <Form.Check
                                                                value={rate_option.id}
                                                                inline
                                                                // label={rate_option.familiarity}
                                                                name="rating"
                                                                type="radio"
                                                                id={`rate-id-${rate_index}`}
                                                                className="btn-check"
                                                                checked={String(activeQuesData.rate_val) === String(rate_option.id) ? true : false}
                                                                onChange={submitEndorse}
                                                                disabled={isLoading}
                                                            />
                                                            <label className={`btn btn-outline-primary ${String(activeQuesData.rate_val) === String(rate_option.id) ? 'active' : (isLoading ? 'disabled' : '')}`} htmlFor={`rate-id-${rate_index}`}>
                                                            {rate_option.familiarity}
                                                            </label>
                                                            </div>
                                                        ))}
                                                        </div>
                                                        </div>
                                                        <div className="align-content-center mt-3 ms-0 ms-sm-3">
                                                            <button
                                                                className="btn btn-light bg-white"
                                                                onClick={(e) => skipQuestion(e, 'skip')}
                                                                disabled={isLoading}
                                                            >
                                                            <img src={SkipIcon} alt="Skip" className="mini-icon"/>
                                                            </button>
                                                        </div>
                                                    </Form>
                                                    </div>
                                                    :
                                                    <>
                                                    {!isLoading && (
                                                    <p className="m-2 mb-3 alert alert-success"><b>You have endorsed all the attributes. Thank You</b>
                                                        <br/>
                                                        <span>Check back later for more Attributes.</span>
                                                    </p>)}
                                                    </>
                                                }
                                            </div>
                                    }
                                    {isLoading && (
                                        <div className="text-center mt-4 mb-4">
                                            <LoaderMedium size={30} />
                                        </div>
                                    )}
                                </div>
                                </div>
                            </div>
                        </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="team-detail">
                <button className="btn btn-secondary" onClick={(e) => props.toggleModal(e, false)}>Close</button>
            </Modal.Footer>
        </Modal>
      </>
    );
}
  
export default ModalEndorsePort;